import React, { useState } from 'react';
import { DragDropContext, Draggable } from '../../../components/shared/DragDropWrapper';
import { StrictModeDroppable } from '../../../components/shared/DragDropWrapper';
import { Box, Button, Typography, Paper } from '@mui/material';

// Mock data
const initialItems = [
  { id: 'item-1', content: 'Item 1' },
  { id: 'item-2', content: 'Item 2' },
  { id: 'item-3', content: 'Item 3' },
  { id: 'item-4', content: 'Item 4' },
];

const TestDragDrop = () => {
  const [items, setItems] = useState(initialItems);
  const [isDraggable, setIsDraggable] = useState(false);

  const handleDragEnd = (result) => {
    console.log('Drag ended:', result);
    
    // Drop outside the list
    if (!result.destination) {
      return;
    }

    // Same position
    if (result.destination.index === result.source.index) {
      return;
    }

    // Reorder the list
    const newItems = [...items];
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);

    setItems(newItems);
    console.log('New items order:', newItems);
  };

  return (
    <Box sx={{ p: 4, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Drag and Drop Test
      </Typography>
      
      <Button 
        variant={isDraggable ? "contained" : "outlined"} 
        color="primary" 
        onClick={() => setIsDraggable(!isDraggable)}
        sx={{ mb: 2 }}
      >
        {isDraggable ? 'Finish Reordering' : 'Enable Drag & Drop'}
      </Button>
      
      <Box sx={{ mb: 2 }}>
        <Typography color="textSecondary">
          Draggable: {isDraggable ? 'Yes' : 'No'}
        </Typography>
        <Typography color="textSecondary">
          Items: {items.map(item => item.content).join(', ')}
        </Typography>
      </Box>
      
      <DragDropContext onDragEnd={handleDragEnd}>
        <StrictModeDroppable droppableId="test-droppable" isDropDisabled={!isDraggable}>
          {(provided) => (
            <Paper
              {...provided.droppableProps}
              ref={provided.innerRef}
              elevation={2}
              sx={{ p: 2 }}
            >
              {items.map((item, index) => (
                <Draggable 
                  key={item.id} 
                  draggableId={item.id} 
                  index={index}
                  isDragDisabled={!isDraggable}
                >
                  {(provided, snapshot) => (
                    <Paper
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      elevation={snapshot.isDragging ? 6 : 1}
                      sx={{
                        p: 2,
                        mb: 2,
                        bgcolor: snapshot.isDragging ? 'primary.light' : 'background.paper',
                        color: snapshot.isDragging ? 'primary.contrastText' : 'text.primary',
                        cursor: isDraggable ? 'grab' : 'default',
                        '&:hover': {
                          bgcolor: isDraggable ? 'action.hover' : 'background.paper',
                        }
                      }}
                    >
                      <Typography>{item.content}</Typography>
                    </Paper>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Paper>
          )}
        </StrictModeDroppable>
      </DragDropContext>
    </Box>
  );
};

export default TestDragDrop; 